import React from "react";
import "./Footer.css";
import { FaFacebookF, FaTwitter, FaLinkedinIn, FaInstagram, FaWhatsapp } from "react-icons/fa";
import { NavLink, useLocation } from "react-router-dom";
import logo from "../assets/logo-white.png"; // replace with your logo path

const Footer = () => {
  const { pathname } = useLocation();

  // Scroll to top whenever a link is clicked
  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return (
    <>
      <footer className="footer">
        <div className="footer-container">
          {/* Left Section */}
          <div className="footer-col">
            <img src={logo} alt="Sreenathi Enterprises" className="footer-logo" />
          </div>

          {/* Company Info */}
          <div className="footer-col company-info">
            <h4>Do you have questions? Call or visit us:</h4>
            <ul>
  <li><a href="tel:+9108023102596">+91 080 - 23102596</a></li>
  <li><a href="tel:+919972601957">+91 9972601957</a></li>
  <li><a href="tel:+919900105451">+91 9900105451</a></li>
</ul>
            <p>
              # 8/8, 1st Cross,<br />
              SSI Area, 5th Block,<br />
              (Behind S.J.R School),<br />
              Rajajinagar, Bangalore 560 010.
            </p>
            <p>
              Email: <a href="mailto:admin@sreenathji.com">admin@sreenathji.com</a>
            </p>
          </div>

          {/* Quick Links */}
          <div className="footer-col quick-links">
            <h3>Quick Links</h3>
            <ul>
              <li>
                <NavLink to="/" className={({ isActive }) => isActive ? "active-link" : ""}>
                  Home
                </NavLink>
              </li>
              <li>
                <NavLink to="/about" className={({ isActive }) => isActive ? "active-link" : ""}>
                  About
                </NavLink>
              </li>
              <li>
                <NavLink to="/partners" className={({ isActive }) => isActive ? "active-link" : ""}>
                  Partners
                </NavLink>
              </li>
              <li>
                <NavLink to="/products" end className={({ isActive }) => isActive ? "active-link" : ""}>
                  Products
                </NavLink>
              </li>
              <li>
                <NavLink to="/careers" className={({ isActive }) => isActive ? "active-link" : ""}>
                  Careers
                </NavLink>
              </li>
              <li>
                <NavLink to="/events" className={({ isActive }) => isActive ? "active-link" : ""}>
                  Events
                </NavLink>
              </li>
              <li>
                <NavLink to="/contact" className={({ isActive }) => isActive ? "active-link" : ""}>
                  Contact Us
                </NavLink>
              </li>
            </ul>
          </div>

          <div className="footer-col quick-links">
            <h3>Our Products</h3>
            <ul>
              <li>
                <NavLink to="/products/plating-and-speciality-chemicals" className={({ isActive }) => isActive ? "active-link" : ""}>
                  Plating and Specialty Chemicals
                </NavLink>
              </li>
              <li>
                <NavLink to="/products/basic-and-lab-chemicals" className={({ isActive }) => isActive ? "active-link" : ""}>
                  Basic and Lab Chemicals
                </NavLink>
              </li>
              <li>
                <NavLink to="/products/metals" className={({ isActive }) => isActive ? "active-link" : ""}>
                Metals
                </NavLink>
              </li>
              <li>
                <NavLink to="/products/abrasives" className={({ isActive }) => isActive ? "active-link" : ""}>
                  Abrasives
                </NavLink>
              </li>
              <li>
                <NavLink to="/products/cutting-tools" className={({ isActive }) => isActive ? "active-link" : ""}>
                  Cutting Tools
                </NavLink>
              </li>     
              <li>
                <NavLink to="/products/wood-glass-coatings" className={({ isActive }) => isActive ? "active-link" : ""}>
                 Wood & Glass Coatings
                </NavLink>
              </li>
              <li>
                <NavLink to="/products/metal-coatings" className={({ isActive }) => isActive ? "active-link" : ""}>
                  Metal Coatings
                </NavLink>
              </li>
                       
            </ul>
          </div>

          {/* Social Icons */}
          <div className="footer-col">
            <h3>Connect with us</h3>
            <div className="social-icons">
              <a href="https://wa.me/9972812736" target="_blank" rel="noopener noreferrer"><FaWhatsapp /></a>        
              <a href="https://www.facebook.com/share/1AzmTpPntq/"><FaFacebookF /></a>
              <a href="https://www.linkedin.com/company/sreenathji-enterprises/"><FaLinkedinIn /></a>
              <a href="https://www.instagram.com/sreenathji_enterprises?utm_source=qr&igsh=ZXN4b2xob2dvMGM5" target="_blank" rel="noopener noreferrer"><FaInstagram /></a>
            </div>
          </div>
        </div>
      </footer>

      {/* Bottom Bar */}
      <div
        style={{
          backgroundColor: "#00558C",
          color: "#ffffff",
          textAlign: "left",
          padding: "15px 0",
          fontSize: "14px",
        }}
      >
        <div className="footer-bottom-last">
          Copyright © 2025, Sreenathji Enterprises. All rights reserved. | 
   Designed & Developed by{" "}
  <a href="https://www.digiworq.com" className="footer-bottom-last-link">
    DIGIWORQ
  </a>{" "}
 
</div>


      </div>
    </>
  );
};

export default Footer;
